import styled from 'styled-components'

export const StickyWrapper = styled.div`
  ${props => props.theme.flyQueries.desktop} {
    position: sticky;
    top: 0;
    z-index: 99;
    transition: transform 0.8s;
  }

  ${props =>
    props.isMobileFilterChip &&
    `position: sticky;
      top: 0;
      z-index: 99;
    `};
`

export const StickyMobileChipWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 99;
`

// Below translateY height should reflect the maximum height the CSH can ever have
export const StickyAnchor = styled.div`
  ${props => props.theme.flyQueries.desktop} {
    display: inline;

    & + .${props => props.hiddenClassName} {
      transform: translateY(-339px);
      overflow: hidden;
    }
  }
`
